import { queryOptions } from "@tanstack/react-query";

import type { components } from "@kansai-ai-hub/api-client";

import { apiClient } from "@/lib/api-client";

/*
 * 型は OpenAPI の生成物から取る（手書きで写すと API 側の項目追加・変更に追随できない）。
 */
export type AdminKakekomiEventSummary = components["schemas"]["AdminKakekomiEventSummaryDto"];
export type AdminKakekomiEventDetail = components["schemas"]["AdminKakekomiEventDetailDto"];
export type AdminKakekomiSlot = components["schemas"]["AdminKakekomiSlotDto"];
export type AdminKakekomiBooking = components["schemas"]["AdminKakekomiBookingDto"];

export const kakekomiKeys = {
  all: ["kakekomi"] as const,
  list: () => [...kakekomiKeys.all, "list"] as const,
  detail: (id: string) => [...kakekomiKeys.all, "detail", id] as const,
} as const;

export function adminKakekomiEventsQueryOptions() {
  return queryOptions({
    queryKey: kakekomiKeys.list(),
    queryFn: (): Promise<AdminKakekomiEventSummary[]> =>
      apiClient.get<AdminKakekomiEventSummary[]>("/api/v1/admin/kakekomi/events"),
    staleTime: 30_000,
  });
}

/**
 * 開催回の詳細（予約者一覧を含む）。
 *
 * 予約は LP から事務局の操作と無関係に入ってくるので、画面に戻ってきたら取り直す
 * （フォーカス時の再取得）。常時ポーリングはしない。
 */
export function adminKakekomiEventQueryOptions(id: string) {
  return queryOptions({
    queryKey: kakekomiKeys.detail(id),
    queryFn: (): Promise<AdminKakekomiEventDetail> =>
      apiClient.get<AdminKakekomiEventDetail>(
        `/api/v1/admin/kakekomi/events/${encodeURIComponent(id)}`,
      ),
    staleTime: 15_000,
    refetchOnWindowFocus: true,
  });
}
